/*
 * events reducer
 */

// Constants
import { RESET_STATE } from '../auth/constants';
import { EVENTS_SET, EVENTS_MERGE, EVENT_SET } from './constants';

const initialState = {};

type State = {};

type Action = {
    type: string;
    payload: any;
};

export default function (state: State = initialState, action: Action): State {
    switch (action.type) {
        case EVENTS_SET:
            return action.payload;
        case EVENTS_MERGE:
            return {
                ...state,
                ...action.payload
            };
        case EVENT_SET:
            return {
                ...state,
                [action.payload.id]: action.payload
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
